export enum ContractStatus {
  DRAFT = 'DRAFT',
  SENT = 'SENT',
  GENERATED = 'GENERATED',
  FILLED = 'FILLED',
  SIGNED = 'SIGNED',
  SEALED = 'SEALED',
  WAITING_FOR_SIGNATURE = 'WAITING_FOR_SIGNATURE',
  PARTIALLY_SIGNED = 'PARTIALLY_SIGNED',
  SEALING_IN_PROGRESS = 'SEALING_IN_PROGRESS',
  GENERATION_IN_PROGRESS = 'GENERATION_IN_PROGRESS',
}

export enum ContractNatureStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}
